import React from 'react';
import { Box, Container, Typography, Grid, Link, IconButton, Divider } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontFamily: '"Tenor Sans", sans-serif',
                  fontWeight: 700,
                  letterSpacing: '.1rem',
                  mb: 2,
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                BONAVIA
                <Box 
                  component="span" 
                  sx={{ 
                    display: 'inline-block', 
                    width: '6px', 
                    height: '6px', 
                    borderRadius: '50%', 
                    bgcolor: 'error.main', 
                    ml: 0.5, 
                    mt: 1 
                  }} 
                />
              </Typography>
              <Typography variant="body2" sx={{ mb: 2, opacity: 0.8 }}>
                Conseil immobilier et accompagnement patrimonial avec le cœur.
              </Typography>
              <Typography variant="body2" sx={{ fontStyle: 'italic', mb: 3, opacity: 0.8 }}>
                Faites les bons choix, suivez la bonne voie.
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <IconButton 
                  size="small" 
                  aria-label="linkedin" 
                  sx={{ 
                    color: 'white',
                    '&:hover': { color: 'error.main' }
                  }}
                >
                  <LinkedInIcon />
                </IconButton>
                <IconButton 
                  size="small" 
                  aria-label="facebook" 
                  sx={{ 
                    color: 'white',
                    '&:hover': { color: 'error.main' }
                  }}
                >
                  <FacebookIcon />
                </IconButton>
                <IconButton 
                  size="small" 
                  aria-label="instagram" 
                  sx={{ 
                    color: 'white',
                    '&:hover': { color: 'error.main' }
                  }}
                >
                  <InstagramIcon />
                </IconButton>
              </Box>
            </motion.div>
          </Grid>
          
          <Grid item xs={12} sm={6} md={4}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <Typography variant="h6" component="h3" sx={{ mb: 2, fontWeight: 600 }}>
                Contact
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, opacity: 0.8 }}>
                Armelle Bonaventure
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, opacity: 0.8 }}>
                📧 abonaventure@hotmail.fr
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, opacity: 0.8 }}>
                📞 +33 6 70 10 22 50
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                📍 Route des Camoins, 13011 Marseille
              </Typography>
            </motion.div>
          </Grid>
          
          <Grid item xs={12} sm={6} md={4}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              <Typography variant="h6" component="h3" sx={{ mb: 2, fontWeight: 600 }}>
                Liens rapides
              </Typography>
              <Link href="#hero" underline="none" color="inherit" sx={{ display: 'block', mb: 1, opacity: 0.8, '&:hover': { opacity: 1, color: 'secondary.main' } }}>
                Accueil
              </Link>
              <Link href="#approach" underline="none" color="inherit" sx={{ display: 'block', mb: 1, opacity: 0.8, '&:hover': { opacity: 1, color: 'secondary.main' } }}>
                Notre approche
              </Link>
              <Link href="#services" underline="none" color="inherit" sx={{ display: 'block', mb: 1, opacity: 0.8, '&:hover': { opacity: 1, color: 'secondary.main' } }}>
                Services
              </Link>
              <Link href="#testimonials" underline="none" color="inherit" sx={{ display: 'block', mb: 1, opacity: 0.8, '&:hover': { opacity: 1, color: 'secondary.main' } }}>
                Témoignages
              </Link>
              <Link href="#contact" underline="none" color="inherit" sx={{ display: 'block', opacity: 0.8, '&:hover': { opacity: 1, color: 'secondary.main' } }}>
                Contact
              </Link>
            </motion.div>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' }} />
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
          <Typography variant="body2" sx={{ opacity: 0.6 }}>
            © {new Date().getFullYear()} BONAVIA. Tous droits réservés.
          </Typography>
          <Box>
            <Link href="#" underline="none" color="inherit" sx={{ opacity: 0.6, mr: 2, '&:hover': { opacity: 1 } }}>
              Mentions légales
            </Link>
            <Link href="#" underline="none" color="inherit" sx={{ opacity: 0.6, '&:hover': { opacity: 1 } }}>
              Politique de confidentialité
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
